import React from 'react';
export const useIsLoading = (...asyncStates) => {
    return React.useMemo(() => asyncStates.some((state) => !!state.isLoading), [...asyncStates]);
};
export const useLoadingEffect = (isLoadingEffect, deps) => {
    const curState = React.useRef(deps.some((state) => !!state.isLoading));
    const returnHandler = React.useRef();
    const isLoading = React.useMemo(() => deps.some((state) => !!state.isLoading), [...deps]);
    React.useEffect(() => {
        if (curState.current !== isLoading) {
            curState.current = isLoading;
            if (isLoading) {
                returnHandler.current = isLoadingEffect?.();
            }
            else {
                returnHandler.current?.();
            }
        }
    }, [isLoading]);
    return { isLoading };
};
//# sourceMappingURL=useIsLoading.js.map